import { COMPANY_ACTION_TYPES } from '../constants';
import { 
	APP_CONSTANTS,
	GLOBAL_CONSTANTS,
	// COMPANY_STATUS,
	// COMPANY_TYPE, 
} from '../../../constants';
import { COMPANY_CONSTANTS } from '../constants';

import { createErrorMessageFromJsonResponse } from '../../../utilities';

import { companyServices } from '../../../api/services';



function requestDeleteOneCompany(){
	return {
		type: COMPANY_ACTION_TYPES.DELETE_ONE_COMPANY_INFO_REQUEST
	}
}

function successDeleteOneCompany(){
	return {
		type: COMPANY_ACTION_TYPES.DELETE_ONE_COMPANY_INFO_SUCCESS,
	}
}



function failureDeleteOneCompany(error){
	return {
		type: COMPANY_ACTION_TYPES.DELETE_ONE_COMPANY_INFO_FAILURE,
		error,
	}
}


function deleteOneCompany(companyId){
	return async (dispatch,getState) => {

    	var { token } = getState().auth;
    	if(!token){
    		token = await localStorage.getItem('token');
    	}


    	if(token){
    		try{
    			await dispatch(requestDeleteOneCompany());


    			let payload ={
		    		companyId: companyId,
			        
		    	}



		    	//## [DEBUG]
	    		// console.log('-----Company Info Update Payload ----')
	    		// console.log(payload)

    			let responseJson = await companyServices
    			.deleteOneCompanyInfo(
    				token,
    				payload
    			);



				if(responseJson){
					if(responseJson.code === GLOBAL_CONSTANTS.CODE_SUCCESS){
						await dispatch(
								successDeleteOneCompany(
									
								)
							);

						return true;
					}
					else if(responseJson.response) {

	                    var errMsg = createErrorMessageFromJsonResponse(responseJson.response.data);
	                        await dispatch(
	                        	failureDeleteOneCompany(errMsg)
	                        );
	                    return false;
	                }
					else if(responseJson.requestError) {
	                    await dispatch(
	                    	failureDeleteOneCompany(
	                    		responseJson.requestError
	                    	)
						);
	                    return false;
	                }
	                else{
	                    await dispatch(
							failureDeleteOneCompany(
								COMPANY_CONSTANTS.ERROR_FAILURE_DELETE_ONE_COMPANY_INFO
							)
						);
		                return false;
	                }
				}
				else{
					await dispatch(
						failureDeleteOneCompany(
							COMPANY_CONSTANTS.ERROR_FAILURE_DELETE_ONE_COMPANY_INFO
						)
					);
	                return false;
				}
    		}
    		catch(error){
    			await dispatch(
    				failureDeleteOneCompany(
    					error.message
    				)
    			);
	    		return false;
    		}
    	}
    	else{
    		await dispatch(
    			failureDeleteOneCompany(
    				APP_CONSTANTS.ERROR_UNAUTHORIZED_REQUEST
    			)
    		);
	    	return false;
    	}
    }
}


//###----------------------------------------------------------------------


export const deleteCompanyActions = {


	requestDeleteOneCompany,
	successDeleteOneCompany,
	failureDeleteOneCompany,
	deleteOneCompany,



}